import { verifyPermission } from '../project/fs'
import { Document } from './Document'
import { DocumentStore } from './DocumentStore'

export class FileDocument extends Document {
  constructor(store: DocumentStore, readonly path: string, readonly fileHandle: FileSystemFileHandle) {
    super(store)
  }

  text: string | undefined
  fileError: Error | undefined

  override async updateText(text: string) {
    this.text = text
    this.fileError = undefined

    // TODO: write to file in background?
    const writable = await this.fileHandle.createWritable()
    await writable.truncate(0)
    await writable.write(text)
    await writable.close()

    this.dispatchChange('text')
  }

  override error(): Error | undefined {
    return this.fileError
  }

  override async reloadContent(retry: boolean = true) {
    if (this.text !== undefined || this.error() !== undefined) {
      return
    }

    try {
      if (!(await verifyPermission(this.fileHandle, 'readwrite'))) {
        this.text = undefined
        this.fileError = new Error('Criteria Playground does not have permission to read the file')
        return
      }

      const file = await this.fileHandle.getFile()
      this.text = await file.text()
      this.fileError = undefined
    } catch (error) {
      console.error(error)
      if (retry && error instanceof DOMException && error.name === 'NotFoundError') {
        // If this file was just created or renamed, might need to wait a bit before reading from the file handle
        setTimeout(() => {
          this.reloadContent(false)
        }, 100)
      } else {
        this.text = undefined
        this.fileError = new Error('Unable to load file', { cause: error })
      }
    }

    this.dispatchChange('text')
  }
}
